import {Component, OnInit} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import { AsyncPipe } from "@angular/common";
import {XTOSReportingService} from "../../../services/XTOS-reporting/xtos-reporting.service";
import {BehaviorSubject} from "rxjs";
import {ExtendedStorage} from "../../../shared/common-components/common-structure";
import {User} from "../../../services/user/user";
import {filter, shareReplay} from "rxjs/operators";
import {XtosShipmentComponent} from "../../xtos-reporting/xtos-shipment/xtos-shipment.component";

@Component({
    selector: 'app-tsp-xtos-single-shipment-report',
    imports: [
    AsyncPipe,
    XtosShipmentComponent
],
    templateUrl: './tsp-xtos-single-shipment-report.component.html',
    styleUrl: './tsp-xtos-single-shipment-report.component.css'
})
export class TspXtosSingleShipmentReportComponent implements OnInit{
  xtosShipmentDetailVM$ = this.xtosReportingService.xtosShipmentDetailData$;
  private selectedExtendedStorage = new BehaviorSubject<ExtendedStorage>(null);
  selectedExtendedStorage$ = this.selectedExtendedStorage.asObservable();
  saveXTOSShipment$: any;
  deleteXTOSShipment$: any;
  user: User;
  isXTOSShipmentSelected;
  excelStyles = [
    {
      id: 'textFormat',
      dataType: 'string',
    }
  ];
  isSysAdmin: boolean;
  isCarrierUser: boolean;
  isAgencyUser: boolean;
  currentUser: User | any;

  constructor(private xtosReportingService: XTOSReportingService) {
  }

  ngOnInit() {
    this.xtosReportingService.user$.pipe(filter(user => user != null))
      .subscribe(user => {
        this.user = user;
        this.currentUser = user;
        this.isSysAdmin = false;
        this.isCarrierUser = false;
        if (user && user.roles) {
          for (const role of user.roles) {
            if (role.name === 'System Admin') {
              this.isSysAdmin = true;
            }
            if (role.id === 4 || role.id === 5 || role.id === 6) {
              this.isCarrierUser = true;
            }
            if (role.id === 3 || role.id === 2) {
              this.isAgencyUser = true;
            }

          }
        }
        this.getXTOSReportingShipments();
      });
  }

  saveXTOSShipment(xtosShipment: ExtendedStorage) {
    this.saveXTOSShipment$ = this.xtosReportingService.saveXTOSShipment(xtosShipment, this.user.id);
    console.log('Parent saveXTOSShipment called', this.saveXTOSShipment$);
  }

  deleteXTOSShipment(xtosShipment: ExtendedStorage) {
    this.deleteXTOSShipment$ = this.xtosReportingService.deleteXTOSShipment(xtosShipment, this.user.id);
  }

  getXTOSReportingShipments() {
    this.xtosReportingService.updateXTOSReportingUserId(this.user.id);
  }

}
